import type { ReactNode } from 'react'
import { cn } from '@/lib/cn'
import styles from './Marquee.module.css'

interface MarqueeProps {
  children: ReactNode
  className?: string
}

/**
 * Continuously scrolling strip.
 *
 * The children render twice: the visible run and a duplicate the animation
 * slides into place, which is what makes the loop seamless. The copy is
 * `aria-hidden` so the accessibility tree sees the content once.
 */
export const Marquee = ({ children, className }: MarqueeProps) => (
  <div className={cn(styles.marquee, className)}>
    <div className={styles.track}>
      <div className={styles.group}>{children}</div>
      <div className={styles.group} aria-hidden="true">
        {children}
      </div>
    </div>
  </div>
)
